var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunnyBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "53.977px",
    height: "39.118px",
    viewBox: "0 0 53.977 39.118",
    enableBackground: "new 0 0 53.977 39.118",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 12.923,
    cy: 22.944,
    r: 2.833
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 40.923,
    cy: 22.944,
    r: 2.833
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M51.602,4.042v8.917c0,0-4.209-12.958-24.833-12.958S2.31,12.958,2.31,12.958v-9 C1.185,2.25,0.019,3.875,0.019,3.875s-0.042,22.5,0,23.583s1.917,11.667,27.418,11.667s26.54-11.25,26.54-11.25V4.083 C52.811,2.042,51.602,4.042,51.602,4.042z M43.021,29.833H11.062c0,0-5.625-1.542-5.625-7.063c0-5.521,5.833-7.063,5.833-7.063 h31.708c0,0,5.458,1.638,5.458,7.236S43.021,29.833,43.021,29.833z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunnyBot);
export default __webpack_public_path__ + "static/media/sunny-bot.e66c9b162047fb54e52b993c6652a2d3.svg";
export { ForwardRef as ReactComponent };